// FormularioNotificaciones.js — Merge Solponiente + SectorBXII
import React, { useState, useEffect } from "react";
import { Form, Button, Table, Badge, ButtonGroup, InputGroup } from "react-bootstrap";

const FormularioNotificaciones = () => {
  const [texto, setTexto] = useState("");
  const [asunto, setAsunto] = useState("");
  const [tipo, setTipo] = useState("normal");
  const [fecha, setFecha] = useState("");
  const [archivo, setArchivo] = useState(null);
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [solicitudes, setSolicitudes] = useState([]);
  const [solicitudSeleccionada, setSolicitudSeleccionada] = useState("");
  const [fileBase64, setFileBase64] = useState("");
  const [nombreDocumento, setNombreDocumento] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [notificaciones, setNotificaciones] = useState([]);
  const [modoFormulario, setModoFormulario] = useState(true);
  const [filtroNotif, setFiltroNotif] = useState("");
  const [estadoFiltroNotif, setEstadoFiltroNotif] = useState("");

  useEffect(() => {
    getUsuarios();
    fetchNotificaciones();
  }, []);

  const getHeaders = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  });

  const getUsuarios = async () => {
    try {
      const response = await fetch(
        "https://oficinavirtual-solponiente.com/api/usuarios",
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      if (response.ok) {
        const data = await response.json();
        setUsuarios(data);
      } else {
        console.error("Error al obtener usuarios");
      }
    } catch (error) {
      console.error("Error al hacer la solicitud:", error);
    }
  };

  const fetchNotificaciones = async () => {
    try {
      const response = await fetch(
        "https://oficinavirtual-solponiente.com/api/notificaciones",
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      if (response.ok) {
        const data = await response.json();
        setNotificaciones(data);
      }
    } catch (error) {
      console.error("Error al obtener notificaciones:", error);
    }
  };

  const getSolicitudes = async (value) => {
    setUsuarioSeleccionado(value);
    setSolicitudSeleccionada("");
    try {
      const response = await fetch(
        `https://oficinavirtual-solponiente.com/api/solicitudes/usuarios/${value}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      if (response.ok) {
        const data = await response.json();
        setSolicitudes(data);
      } else {
        setSolicitudes([]);
      }
    } catch (error) {
      setSolicitudes([]);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setNombreDocumento(file.name);
      const reader = new FileReader();
      reader.onload = () => {
        const base64Data = reader.result.split(",")[1];
        setFileBase64(base64Data);
      };
      reader.readAsDataURL(file);
    }
  };

  const sendDocument = async (usuarioId) => {
    const documentData = {
      NombreDocumento: nombreDocumento,
      Documento: fileBase64,
      usuario_id: usuarioId,
    };

    try {
      const response = await fetch(
        "https://oficinavirtual-solponiente.com/api/documentos",
        {
          method: "POST",
          headers: getHeaders(),
          body: JSON.stringify(documentData),
        }
      );
      if (response.ok) {
        const result = await response.json();
        return result.DocumentoID;
      } else {
        alert("Error al guardar el documento.");
        return null;
      }
    } catch (error) {
      alert("No se pudo conectar con la base de datos.");
      return null;
    }
  };

  const publicarNotificacion = async (formData) => {
    try {
      const response = await fetch(
        "https://oficinavirtual-solponiente.com/api/notificaciones",
        {
          method: "POST",
          headers: getHeaders(),
          body: JSON.stringify({
            UsuarioID: formData.usuarioId,
            SolicitudID: formData.solicitudId || null,
            FechaEnvio: formData.fecha,
            FechaRecepcion: null,
            Recepcion: false,
            Firmado: false,
            FechaFirma: null,
            Asunto: formData.asunto,
            Tipo: formData.tipo,
            Descripcion: formData.texto,
            DocumentoID: formData.documentoId,
          }),
        }
      );
      if (!response.ok) {
        throw new Error(`Error al publicar: ${response.statusText}`);
      }
      alert("Notificación publicada con éxito.");
      fetchNotificaciones();
    } catch (error) {
      alert("Hubo un error al publicar la notificación.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!asunto || !texto || !fecha || !usuarioSeleccionado) {
      alert("Por favor, complete todos los campos requeridos.");
      return;
    }
    setEnviando(true);
    const docId = await sendDocument(usuarioSeleccionado);
    if (!docId) {
      setEnviando(false);
      return;
    }

    await publicarNotificacion({
      texto,
      asunto,
      tipo,
      fecha,
      usuarioId: usuarioSeleccionado,
      solicitudId: solicitudSeleccionada,
      documentoId: docId,
    });

    // Reset formulario
    setTexto("");
    setAsunto("");
    setTipo("normal");
    setFecha("");
    setArchivo(null);
    setUsuarioSeleccionado("");
    setSolicitudes([]);
    setSolicitudSeleccionada("");
    setNombreDocumento("");
    setFileBase64("");
    setEnviando(false);
  };

  return (
    <div>
      {/* Toggle Crear / Histórico */}
      <ButtonGroup className="mb-4">
        <Button
          variant={modoFormulario ? "primary" : "outline-primary"}
          onClick={() => setModoFormulario(true)}
        >
          Crear Notificación
        </Button>
        <Button
          variant={!modoFormulario ? "primary" : "outline-primary"}
          onClick={() => setModoFormulario(false)}
        >
          Ver Histórico
        </Button>
      </ButtonGroup>

      {modoFormulario ? (
        <Form onSubmit={handleSubmit}>
          {/* Selector de usuario */}
          <Form.Group controlId="usuario">
            <Form.Label>Seleccione un usuario</Form.Label>
            <Form.Control
              className="mb-3"
              as="select"
              value={usuarioSeleccionado}
              onChange={(e) => getSolicitudes(e.target.value)}
            >
              <option value="">Seleccione un usuario</option>
              {usuarios.map((usuario) => (
                <option key={usuario.UsuarioID} value={usuario.UsuarioID}>
                  {usuario.Nombre} {usuario.Apellidos}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          {/* Asunto */}
          <Form.Group controlId="asunto">
            <Form.Label>Asunto</Form.Label>
            <Form.Control
              type="text"
              value={asunto}
              onChange={(e) => setAsunto(e.target.value)}
              placeholder="Ejemplo: Revisión de solicitud, Subsanación, etc."
            />
          </Form.Group>

          {/* Tipo de notificación */}
          <Form.Group controlId="tipo" className="mt-3">
            <Form.Label>Tipo de notificación</Form.Label>
            <Form.Control
              as="select"
              value={tipo}
              onChange={(e) => setTipo(e.target.value)}
            >
              <option value="normal">Normal</option>
              <option value="subsanacion">Subsanación (requiere que el usuario aporte documentación)</option>
            </Form.Control>
          </Form.Group>

          {/* Solicitud asociada (solo si hay solicitudes para ese usuario) */}
          {solicitudes.length > 0 && (
            <Form.Group controlId="solicitud">
              <Form.Label className="mt-3">
                Asociar a una solicitud (opcional)
              </Form.Label>
              <Form.Control
                className="mb-2"
                as="select"
                value={solicitudSeleccionada}
                onChange={(e) => setSolicitudSeleccionada(e.target.value)}
              >
                <option value="">-- Ninguna --</option>
                {solicitudes.map((s) => (
                  <option key={s.SolicitudID} value={s.SolicitudID}>
                    {s.Descripcion}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          )}

          {/* Texto */}
          <Form.Group controlId="texto">
            <Form.Label className="mt-3">Texto de Notificación</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={texto}
              onChange={(e) => setTexto(e.target.value)}
              placeholder="Escribe aquí el texto de la notificación..."
            />
          </Form.Group>

          {/* Fecha */}
          <Form.Group controlId="fecha" className="mt-3">
            <Form.Label>Fecha</Form.Label>
            <Form.Control
              type="date"
              value={fecha}
              onChange={(e) => setFecha(e.target.value)}
            />
          </Form.Group>

          {/* Archivo */}
          <Form.Group controlId="archivo" className="mt-3">
            <Form.Label>Archivo Adjunto</Form.Label>
            <Form.Control type="file" onChange={handleFileChange} />
          </Form.Group>

          {usuarioSeleccionado && (
            <Button
              variant="primary"
              type="submit"
              className="mt-4 w-100"
              disabled={enviando}
            >
              {enviando ? "Enviando..." : "Enviar Notificación"}
            </Button>
          )}
        </Form>
      ) : (
        <>
          <h5 className="section-title">Histórico de Notificaciones</h5>
          <div className="d-flex flex-column flex-md-row gap-2 mt-3 mb-3">
            <InputGroup>
              <InputGroup.Text><i className="bi bi-search"></i></InputGroup.Text>
              <Form.Control
                placeholder="Buscar por DNI o nombre…"
                value={filtroNotif}
                onChange={(e) => setFiltroNotif(e.target.value)}
              />
              {filtroNotif && (
                <Button variant="outline-secondary" onClick={() => setFiltroNotif("")}>✕</Button>
              )}
            </InputGroup>
            <Form.Select
              value={estadoFiltroNotif}
              onChange={(e) => setEstadoFiltroNotif(e.target.value)}
              style={{ maxWidth: 200 }}
            >
              <option value="">Todos los estados</option>
              <option value="firmada">Firmada</option>
              <option value="pendiente">Pendiente</option>
            </Form.Select>
          </div>
          <Table striped bordered hover responsive className="mt-3">
            <thead className="thead-brand thead-label">
              <tr>
                <th>Usuario</th>
                <th>Asunto</th>
                <th>Tipo</th>
                <th>Fecha de Envío</th>
                <th>Estado</th>
                <th>Fecha de Firma</th>
              </tr>
            </thead>
            <tbody>
              {notificaciones
                .filter((n) => {
                  const term = filtroNotif.toLowerCase();
                  const coincideTexto =
                    !term ||
                    n.NombreUsuario?.toLowerCase().includes(term) ||
                    n.NumIdentificacion?.toLowerCase().includes(term);
                  const coincideEstado =
                    !estadoFiltroNotif ||
                    (estadoFiltroNotif === "firmada" ? n.Firmado : !n.Firmado);
                  return coincideTexto && coincideEstado;
                })
                .map((n) => (
                <tr key={n.NotificacionID}>
                  <td>{n.NombreUsuario || n.UsuarioID}</td>
                  <td>{n.Asunto || "—"}</td>
                  <td>
                    {n.Tipo === "subsanacion" ? (
                      <Badge bg={n.Subsanada ? "success" : "warning"} text={n.Subsanada ? undefined : "dark"}>
                        {n.Subsanada ? "Subsanada" : "Subsanación pendiente"}
                      </Badge>
                    ) : n.Tipo === "justificante" ? (
                      <Badge bg="info" text="dark">Justificante</Badge>
                    ) : (
                      <Badge bg="secondary">Normal</Badge>
                    )}
                  </td>
                  <td>{new Date(n.FechaEnvio).toLocaleDateString("es-ES")}</td>
                  <td>
                    <Badge bg={n.Firmado ? "success" : "warning"}>
                      {n.Firmado ? "Firmada" : "Pendiente"}
                    </Badge>
                  </td>
                  <td>
                    {n.FechaFirma
                      ? new Date(n.FechaFirma).toLocaleDateString("es-ES")
                      : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </div>
  );
};

export default FormularioNotificaciones;
